import { ValidTelemetryEvent } from './TelemetrySender';

/**
 * All the event schemas in this file must be registered in self-service-analytics.tsi.lan:
 * https://mytableau.tableaucorp.com/pages/viewpage.action?spaceKey=devprocess&title=Getting+Started+with+Telemetry+@+Tableau#GettingStartedwithTelemetry@Tableau-create-event-schema
 */

export enum TelemetryEvents {
  DataDisplayedInSharedDialog = 'dataDisplayedInSharedDialog',
}

// Really this wants to extend ValidTelemetryEvent with itself, but that causes "recursive definition"
// compile errors in this module, even though in other modules (e.g., cp2ts) it works perfectly fine.
// Having an empty interface that makes the compiler happy seems better than duplicating all the
// properties here.
// TODO: remove this and use useTelemetrySender instead so we don't need recursive definitions, the fact this works in other modules is not a good thing.
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface DataDisplayedInSharedDialog extends ValidTelemetryEvent<DataDisplayedInSharedDialogInternalToBreakRecursiveDefinition> {
}

interface DataDisplayedInSharedDialogInternalToBreakRecursiveDefinition {
  type: TelemetryEvents.DataDisplayedInSharedDialog;

  typeOfDataDisplayed: string;
  displayDuration: number;
}
